export const getColorCode = color => {
  switch (color) {
    case 'azure':
      return '#41e5c0';
    case 'blue-alt':
      return '#65a6ff';
    case 'orange':
      return '#ef7f27';
  }
};
